import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { TRANSLATION_KEYS_NAMESPACES } from '@proman/shared/language/translation-utils';

export class CustomMissingTranslationHandler implements MissingTranslationHandler {
    handle(params: MissingTranslationHandlerParams) {
        let key: string = params.key;

        if (key.includes('.')) {
            const parts = key.split('.');

            const translationDomain = TRANSLATION_KEYS_NAMESPACES.find((a) => a === parts[0]);

            if (translationDomain) {
                key = key.split(`${translationDomain}.`)[1] as string;
            }
        }

        key = key.split('_').join(' ');

        key = key.charAt(0).toUpperCase() + key.slice(1);

        return key;
    }
}
